import { supabase } from '@/features/sistema/services/supabaseClient';

const UNREAD_BY_OBRA_RPC = 'fn_app_unread_by_obra';

type UnreadByObraRow = {
  obra_id: string | null;
  unread_count: number | null;
};

async function callUnreadByObraRpc({
  obraId,
  usuarioId,
  onlyMentions,
}: {
  obraId: string;
  usuarioId?: string | null;
  onlyMentions: boolean;
}) {
  const { data, error } = await supabase.rpc(UNREAD_BY_OBRA_RPC, {
    p_obra_id: obraId,
    p_usuario_id: usuarioId ?? null,
    p_only_mentions: onlyMentions,
  });

  if (error) {
    throw error;
  }

  const rows = Array.isArray(data) ? (data as UnreadByObraRow[]) : [];
  const row = rows.length > 0 ? rows[0] : null;
  return row?.unread_count ?? 0;
}

export async function getUnreadCountByObra(obraId: string, usuarioId?: string | null) {
  if (!obraId) {
    return 0;
  }

  return callUnreadByObraRpc({ obraId, usuarioId, onlyMentions: false });
}

export async function getUnreadMentionCountByObra(obraId: string, usuarioId: string) {
  if (!obraId || !usuarioId) {
    return 0;
  }

  return callUnreadByObraRpc({ obraId, usuarioId, onlyMentions: true });
}

